import React, { useState } from 'react';
import { Button } from '@hover/blueprint/brand';
import { Body, Box, BoxProps, Icon, TextInput } from '@hover/blueprint';
import { iMail } from '@hover/icons';
import { emailValidation } from '../../../utils';

interface Props extends BoxProps {
  iconColor: string;
}

const NewsLetterForm: React.FC<Props> = ({ iconColor, ...restProps }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const [email, setEmail] = useState<string>('');

  const subNewsLetter = () => {
    if (email.length) {
      if (!emailValidation(email)) {
        setError(true);
      } else {
        setError(false);
        setLoading(true);
        const bodyParams = JSON.stringify({
          attributes: [
            {
              external_id: email,
              email,
              newsletter: true,
            },
          ],
        });

        fetch('https://rest.iad-03.braze.com/users/track', {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer 5eacfc5a-1625-415e-80cc-55d28e3fe895',
          },
          method: 'post',
          body: bodyParams,
        })
          .then(() => {
            setLoading(false);
            setEmail('');
          })
          .catch(() => {
            setLoading(false);
            setEmail('');
          });
      }
    }
  };

  return (
    <Box flex={1} flexDir="column" {...restProps}>
      <Icon m={0} icon={iMail} color={iconColor} size="large" />
      <Body as="h3" color="neutral.0" size={500} isBold pt={500} pb={400}>
        JOIN OUR NEWSLETTER
      </Body>
      <Box display="flex">
        <Body width="70%" color="neutral.0" size={500} pb={500}>
          We’ll send you periodical articles and product updates. No
          spam...promise.
        </Body>
      </Box>
      <Box
        d="flex"
        alignItems={{ base: 'flex-start', desktop: 'flex-end' }}
        flexDir={{ base: 'column', desktop: 'row' }}
        justifyContent="flex-start"
      >
        <Box flexDir="column" mt={300} w="100%" maxW="350px">
          <Body
            w="auto"
            color="brandNavy.200"
            size={300}
            letterSpacing="1px"
            isBold
            mb={100}
          >
            EMAIL
          </Body>
          <Box
            mb={{ base: 700, desktop: 0 }}
            flexDir="column"
            position="relative"
          >
            <TextInput
              width="100%"
              name="search"
              placeholder="youremail@example.com"
              borderColor="transparent"
              _placeholder={{
                color: 'brandNavy.300',
                fontSize: '12px',
                letterSpacing: '0.15em',
                lineHeight: '24px',
                fontWeight: 'bold',
                textTransform: 'uppercase',
              }}
              onChange={e => {
                setEmail(e.target.value);
                if (error && emailValidation(email)) {
                  setError(false);
                }
              }}
              error={error}
            />
            {error && (
              <Body
                w="auto"
                color="danger.300"
                size={300}
                letterSpacing="1px"
                my={100}
                position="absolute"
                top="100%"
              >
                Please enter your email in the correct format.
              </Body>
            )}
          </Box>
        </Box>
        <Button
          variant="inverted"
          maxW={{ base: '170px', desktop: '120px' }}
          w="100%"
          ml={{ base: 0, desktop: 500 }}
          colorScheme="brandNavy"
          whiteSpace="nowrap"
          type="button"
          isLoading={loading}
          onClick={subNewsLetter}
        >
          Sign up
        </Button>
      </Box>
    </Box>
  );
};

export default NewsLetterForm;
